import script from "./relationDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./relationDevice.vue?vue&type=script&setup=true&lang=js"

import "./relationDevice.vue?vue&type=style&index=0&id=0598281d&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0598281d"]])

export default __exports__